import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  findCarteBySocieteApi,
  ListCartes,
} from "../../_App/Redux/Slices/cartes/carteSlice";
import {
  findCategorieBySocieteApi,
  ListCategories,
} from "../../_App/Redux/Slices/categories/categorieSlice";
import {
  findSousCategorieBySociete,
  ListSousCategories,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { stockfilterApi } from "../../_App/Redux/Slices/article/articleSlice";
import {
  findProductsCaracteristiquesApiBySociete,
  ListProductCaracteristiques,
} from "../../_App/Redux/Slices/product_caracteristique/product_caracteristiqueSlice";
import { ListNumberPagecentaines } from "../../_App/Data/ListNumberPage";
import {
  findProductsMarquesApiBySociete,
  ListProductMarques,
} from "../../_App/Redux/Slices/product_marque/product_marque";

export default function Filtre({
  t,
  set_search_element,
  handleSearch,
  setkeyword,
  searchfiltre,
  selectedCarte,
  setSelectedCarte,
  selectedCategorie,
  setSelectedCategorie,
  setSelectedSousCategorie,
  categoriesOptions,
  setcategoriesdOptions,
  selectedSousCategorie,
  setsouscategoriesdOptions,
  selections,
  setSelections,
  setintervaleRef,
  intervaleRef,
  intervalePrix,
  setintervalePrix,
  souscategoriesOptions,
  selectedMarques,
  setSelectedMarques,
  setNLigne,
  NLigne,
}: any) {
  const dispatch = useAppDispatch();

  const societeid = useAppSelector(societeId);
  const cartes = useAppSelector(ListCartes);
  const categories = useAppSelector(ListCategories);
  const sousCategories = useAppSelector(ListSousCategories);
  const carateristique = useAppSelector(ListProductCaracteristiques);
  //const [scan , setScan]=useState()
  useEffect(() => {
    if (societeid) {
      const fetchData = async () => {
        await dispatch(findCarteBySocieteApi(societeid));
        await dispatch(findCategorieBySocieteApi(societeid));
        await dispatch(findSousCategorieBySociete(societeid));
        await dispatch(findProductsCaracteristiquesApiBySociete(societeid));
        await dispatch(findProductsMarquesApiBySociete(societeid));
      };
      fetchData();
    }
  }, [societeid]);
  /************marque*****/
  const listProductMarque = useAppSelector(ListProductMarques);
  const optionsMarque: any = listProductMarque.map((item) => ({
    value: item._id.toString(),
    label: item.libelle?.fr || item.libelle,
  }));

  /* */
  useEffect(() => {
    if (selectedCarte?.length !== 0) {
      const listcategoriescarte = categories?.filter((item: any) =>
        selectedCarte?.includes(item.carte_id)
      );
      setcategoriesdOptions(
        listcategoriescarte?.map((option) => ({
          value: option._id,
          label: option.libelle.fr,
        }))
      );
    } else {
      setcategoriesdOptions(
        categories?.map((option) => ({
          value: option._id,
          label: option.libelle.fr,
        }))
      );
    }
  }, [selectedCarte]);

  useEffect(() => {
    if (selectedCategorie?.length !== 0) {
      const ListSousCategoriescategories = sousCategories?.filter((item: any) =>
        selectedCategorie?.includes(item.categorie_id)
      );
      setsouscategoriesdOptions(
        ListSousCategoriescategories?.map((option) => ({
          value: option._id,
          label: option.libelle.fr,
        }))
      );
    } else {
      setsouscategoriesdOptions(
        sousCategories?.map((option) => ({
          value: option._id,
          label: option.libelle.fr,
        }))
      );
    }
  }, [selectedCategorie]);

  const CartesOptions = cartes?.map((option) => ({
    value: option._id,
    label: option.libelle.fr,
  }));
  useEffect(() => {
    const updatedOptions =
      sousCategories?.map((option) => ({
        value: option._id,
        label: option.libelle.fr,
      })) || [];

    setsouscategoriesdOptions(updatedOptions);
  }, [sousCategories]);

  const handleSelectChangeCartes = (selectedOption: any) => {
    const cartes = selectedOption.map((item: any) => item.value);
    setSelectedCarte(cartes);
  };
  const handleSelectChangeCategories = (selectedOption: any) => {
    const categorie = selectedOption.map((item: any) => item.value);
    setSelectedCategorie(categorie);
  };
  const handleSelectChangeSousCategories = (selectedOption: any) => {
    const souscategorie = selectedOption.map((item: any) => item.value);
    setSelectedSousCategorie(souscategorie);
  };
  const handleMarqueChange = (selected: any) => {
    setSelectedMarques(selected || []);
  };

  const handleSelectcarateristique = (newSelectedOptions: any, item: any) => {
    setSelections({
      ...selections,
      [item._id]: newSelectedOptions,
    });
  };
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        searchfiltre();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [searchfiltre]);

  return (
    <div>
      <div className="  bg-white" style={{ padding: "10px" }}>
        <div className="row">
          {CartesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="carte">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Carte")}
                </label>
                <Select
                  isMulti
                  options={CartesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeCartes}
                  value={selectedCarte?.map((item: any) =>
                    CartesOptions?.find((cat: any) => cat.value === item)
                  )}
                />
              </div>
            </div>
          )}
          {categoriesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="categorie">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Categorie")}
                </label>
                <Select
                  isMulti
                  options={categoriesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeCategories}
                  value={selectedCategorie?.map((item: any) =>
                    categoriesOptions?.find((cat: any) => cat.value === item)
                  )}
                />
              </div>
            </div>
          )}
          {souscategoriesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="sous">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("sous categorie")}
                </label>
                <Select
                  isMulti
                  options={souscategoriesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeSousCategories}
                  value={selectedSousCategorie?.map((item: any) =>
                    souscategoriesOptions?.find(
                      (cat: any) => cat.value === item
                    )
                  )}
                />
              </div>
            </div>
          )}

          {selectedMarques && optionsMarque?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="sous">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Marque")}
                </label>
                <Select
                  isMulti
                  options={optionsMarque}
                  value={selectedMarques}
                  onChange={handleMarqueChange}
                  placeholder="Sélectionner  marques"
                />
              </div>
            </div>
          )}

          {carateristique &&
            carateristique.map((item, index) => (
              <div className="col-3" key={index}>
                <label htmlFor="sous">
                  <span style={{ color: "red" }}></span>
                  {item.libelle}
                </label>

                <Select
                  isMulti
                  options={
                    item.valeurs &&
                    item.valeurs?.map((v: any) => ({
                      value: { caracteristique_id: item._id, value: v },
                      label: typeof v === "string" ? v : v.libelle,
                    }))
                  }
                  isSearchable={true}
                  onChange={(newSelectedOptions) =>
                    handleSelectcarateristique(newSelectedOptions, item)
                  }
                />
              </div>
            ))}

          <div className="col-md-3 mt-4 mb-2">
            <div className="wrapper">
              <input
                type="text"
                className="w-100 form-control product-search br-30"
                id="input-search"
                placeholder={t("mot cle")}
                onChange={(e) => setkeyword(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3 mt-4 mb-2">
            <div className="wrapper">
              <label> {"Element de recherche"}</label>
              <select
                onChange={(e) => set_search_element(e.target.value)}
                className="w-100 form-control product-search br-30"
              >
                <option value={"article"}>{t("Article")}</option>
                <option value={"famille"}>{t("Famille")}</option>
                <option value={"reference"}>{t("Réference")}</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-5 ">
            <div className="form-group ">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Intervale reference")}
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("ref 1")}
                    onChange={(e) =>
                      setintervaleRef({ ...intervaleRef, ref1: e.target.value })
                    }
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("ref 2")}
                    onChange={(e) =>
                      setintervaleRef({ ...intervaleRef, ref2: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-5 ">
            <div className="form-group ">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Intervale prix")}
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="number"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("prix 1")}
                    onChange={(e) =>
                      setintervalePrix({
                        ...intervalePrix,
                        prix1: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("prix 2")}
                    onChange={(e) =>
                      setintervalePrix({
                        ...intervalePrix,
                        prix2: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {NLigne && (
            <div className="col-1">
              <label> {"N des lignes"}</label>
              <select
                onChange={(e) => setNLigne(e.target.value)}
                value={NLigne || 200}
                className="w-100 form-control product-search br-30"
              >
                {ListNumberPagecentaines.map((a) => (
                  <option key={a} value={a}>
                    {a}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div
            className="col-1 mt-4"
            style={{ fontSize: "30px" }}
            onClick={searchfiltre}
          >
            {" "}
            <i className="fas fa-search"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
